export default __webpack_public_path__ + "static/media/all_w640.6f030930.jpeg";